export const modalAdicionarObservacaoStyles = {}
